import React from 'react';
import { LogIn, LogOut, User } from 'lucide-react';

/**
 * Authentication button component
 * @param {Object} props
 * @param {Function} props.onLoginClick - Callback when login button is clicked
 * @param {boolean} props.isAuthenticated - Whether user is authenticated
 * @param {Function} props.onLogout - Callback when logout button is clicked
 * @param {string} props.language - Current language ('fr' or 'en')
 */
const AuthButton = ({ onLoginClick, isAuthenticated, onLogout, language = 'fr' }) => {
    const userEmail = localStorage.getItem('userEmail');

    if (isAuthenticated) {
        return (
            <div className="flex gap-2 items-center">
                <div className="flex items-center gap-1 px-3 py-1 bg-gray-100 rounded-md text-sm">
                    <User className="w-4 h-4 text-linkoo-purple" />
                    <span className="text-gray-700 max-w-32 truncate">{userEmail}</span>
                </div>
                <button
                    onClick={onLogout}
                    className="px-3 py-1 rounded-md text-sm font-medium transition-colors bg-red-500 text-white hover:bg-red-600 flex items-center gap-1"
                >
                    <LogOut className="w-4 h-4" />
                    {language === 'fr' ? 'Déconnexion' : 'Logout'}
                </button>
            </div>
        );
    }

    return (
        <button
            onClick={onLoginClick}
            className="px-3 py-1 rounded-md text-sm font-medium transition-colors bg-gradient-to-r from-linkoo-purple to-linkoo-pink text-white hover:opacity-90 flex items-center gap-1"
        >
            <LogIn className="w-4 h-4" />
            {language === 'fr' ? 'Connexion' : 'Login'}
        </button>
    );
};

export default AuthButton;
